export interface DocsNavItem {
  title: string;
  href: string;
  keywords?: string;
}

export interface DocsNavGroup {
  title: string;
  items: DocsNavItem[];
}

/**
 * Single source of truth for the docs navigation tree. Consumed by the sidebar
 * (active-route highlighting + filter) and by the prev/next pager.
 */
export const DOCS_NAV: DocsNavGroup[] = [
  {
    title: 'Getting started',
    items: [
      { href: '/docs', title: 'Introduction', keywords: 'overview what is silker runtime security how it works' },
      { href: '/docs/quickstart', title: 'Quickstart', keywords: 'install sdk npm initialize setup verify express' },
      { href: '/docs/frameworks', title: 'Frameworks & deployment', keywords: 'express nextjs nestjs fastify docker proxy cloudflare vercel kubernetes' },
    ],
  },
  {
    title: 'Configuration',
    items: [
      { href: '/docs/configuration', title: 'SDK configuration', keywords: 'initsilker options env apikey appid profile remote config redis store rate limit' },
      { href: '/docs/security', title: 'Security features', keywords: 'owasp top 10 sqli xss csrf ssrf prompt injection detection reference' },
    ],
  },
  {
    title: 'Platform',
    items: [
      { href: '/docs/dashboard', title: 'Dashboard', keywords: 'apps api keys alerts banned ips threats team monitoring' },
      { href: '/docs/plans', title: 'Plans & limits', keywords: 'pricing quota requests rate limit free pro business enterprise' },
      { href: '/docs/data', title: 'Data & privacy', keywords: 'ingest what data sent pii redaction gdpr retention sanitization' },
    ],
  },
  {
    title: 'Help',
    items: [
      { href: '/docs/troubleshooting', title: 'Troubleshooting', keywords: 'errors faq not working api key invalid no data quota' },
    ],
  },
];

/** Flat, ordered list of pages for prev/next navigation. */
export const DOCS_PAGES_FLAT: DocsNavItem[] = DOCS_NAV.flatMap((group) => group.items);
